import React, {useEffect, useState} from 'react';
import {View, Text, ScrollView, Image, TouchableOpacity} from 'react-native';
import {
  getDiagnoseTestRecord,
  GetScheduleData,
  ScheduleItem,
} from '../../../API/newHome';
import {createStyles} from '../../../utils/createStyles';
import LinearGradient from 'react-native-linear-gradient';
import {logApi} from '../../../API/base';
import {useNavigation} from '@react-navigation/native';
import IntentLauncher, {
  IntentConstant,
} from '@suxueweibo/react-native-intent-launcher';
import {fetchQuestionsByRecordId} from '../../../store/xueke';
import {hideGlobalLoading} from '../../../components/Loading/GlobalLoading';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import Toast from 'react-native-toast-message';
import {selectUserInfo} from '../../../store/user';
import UpgradeModal from '../../../components/UpgradeModal';
interface ScheduleTimelineProps {
  scheduleList: GetScheduleData['scheduleList'];
  onItemClick?: () => void; // 新增的 prop
}

const ScheduleTimelineItem: React.FC<{
  item: GetScheduleData['scheduleList'][0];
  isCurrentTime: boolean;
  goToPage: (item: ScheduleItem) => void;
}> = ({item, isCurrentTime, goToPage}) => {
  return (
    <View style={styles.itemContainer}>
      <View style={styles.circleContainer}>
        <View style={[styles.circle, isCurrentTime && styles.filledCircle]} />
      </View>
      <View style={styles.timeAndContentContainer}>
        <Text style={styles.timeAndContentText}>
          {item.time} {item.content}
        </Text>
      </View>
      {item.logo && (
        <TouchableOpacity onPress={() => goToPage(item)}>
          <LinearGradient
            colors={['#FFFFFF', '#EFF8FF']}
            start={{x: 0, y: 0}}
            end={{x: 0, y: 1}}
            style={styles.logoContainer}>
            <Image source={{uri: item.logo}} style={styles.logo} />
            <View style={styles.logoTextContainer}>
              <Text style={styles.subtitleText}>{item.subTitle}</Text>
              <View style={styles.goToContainer}>
                <Text style={styles.goToText}>前往</Text>
                <Image
                  source={{
                    uri: 'https://media.oss.leziedu.com/webapp/classroom/newPad/right_icon.png',
                  }}
                  style={styles.goToIcon}
                />
              </View>
            </View>
          </LinearGradient>
        </TouchableOpacity>
      )}
    </View>
  );
};

const ScheduleTimeline: React.FC<ScheduleTimelineProps> = ({
  scheduleList,
  onItemClick,
}) => {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const userInfo = useAppSelector(selectUserInfo);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [currentTest, setCurrentTest] = useState<ScheduleItem | null>(null);
  if (!scheduleList || scheduleList.length === 0) {
    return (
      <View style={styles.emptyContainer}>
        <Text style={styles.emptyText}>暂无日程安排</Text>
      </View>
    );
  }
  const currentTime = new Date().toLocaleTimeString('zh-CN', {
    hour: '2-digit',
    minute: '2-digit',
  });
  const getRecordId = async () => {
    try {
      const res = await getDiagnoseTestRecord({
        term: userInfo?.curriculumSetup?.xkwTerm as any,
        gradeId: userInfo?.curriculumSetup?.xkwGradeId as any,
        subjectId: currentTest?.params.subject as any,
      });
      return res.data.generateRecordId;
    } catch (e) {
      return '';
    }
  };
  const handleOnConfirmModal = async () => {
    console.log('重新生成');
    const recordId = await getRecordId();
    setShowUpgradeModal(false);
    if (!recordId) {
      try {
        logApi({
          // @ts-ignore
          useFunction: 'TestDetails',
          bizId: '',
        });
      } catch (e) {}
      navigation.navigate(currentTest?.path as any, {
        grade: userInfo?.curriculumSetup?.xkwGradeId,
        subject: currentTest?.params.subject,
        term: userInfo?.curriculumSetup?.xkwTerm,
      });
      return;
    }
    try {
      logApi({
        // @ts-ignore
        useFunction: 'TestDetails',
        bizId: '',
      });
    } catch (e) {}
    // @ts-ignore
    navigation.navigate('TestDetails', {
      recordId: currentTest?.params.recordId,
    });
  };
  const handleOnCancelModal = () => {
    try {
      logApi({
        // @ts-ignore
        useFunction: 'TestDetails',
        bizId: '',
      });
    } catch (e) {}
    console.log('继续评测');
    setShowUpgradeModal(false);
    dispatch(
      fetchQuestionsByRecordId({
        generateRecordId: currentTest?.params.recordId,
      }),
    )
      .unwrap()
      .then(res => {
        if (res) {
          // @ts-ignore
          navigation.navigate('TestDetails', {
            recordId: currentTest?.params.recordId,
          });
        } else {
          Toast.show({
            text1: '获取题目失败,请稍后重试',
            type: 'error',
          });
        }
      })
      .finally(() => {
        hideGlobalLoading();
      });
  };
  const goToPage = (item: ScheduleItem) => {
    // 记录日程点击
    onItemClick?.();
    if (item.clickTo === 1) {
      console.log('item.path', item.path);
      if (item.params) {
        if (
          item.path === 'InitialSubjectTest' &&
          item.params.recordId &&
          item.params.status === 'completed'
        ) {
          try {
            logApi({
              // @ts-ignore
              useFunction: 'AnswerReport',
              bizId: '',
            });
          } catch (e) {}
          // @ts-ignore@ts-ignore
          navigation.navigate('AnswerReport', {id: item.params.recordId});
          return;
        }
        // @ts-ignore
        if (item.path === 'InitialSubjectTest' && item.params.recordId) {
          if (
            item.params.grade !== userInfo?.curriculumSetup?.xkwGradeId ||
            item.params.term !== userInfo?.curriculumSetup?.xkwTerm
          ) {
            setCurrentTest(item);
            setShowUpgradeModal(true);
            return;
          }
          dispatch(
            fetchQuestionsByRecordId({generateRecordId: item.params.recordId}),
          )
            .unwrap()
            .then(res => {
              if (res) {
                try {
                  logApi({
                    // @ts-ignore
                    useFunction: 'TestDetails',
                    bizId: '',
                  });
                } catch (e) {}
                // @ts-ignore
                navigation.navigate('TestDetails', {
                  recordId: item.params.recordId,
                });
              } else {
                Toast.show({
                  text1: '获取题目失败,请稍后重试',
                  type: 'error',
                });
              }
            })
            .finally(() => {
              hideGlobalLoading();
            });
        } else {
          // @ts-ignore
          navigation.navigate(item.path, item.params);
        }
      } else {
        try {
          logApi({
            // @ts-ignore
            useFunction: item.path,
            bizId: '',
          });
        } catch (e) {}
        // @ts-ignore
        navigation.navigate(item.path);
      }
    } else if (item.clickTo === 2) {
      try {
        logApi({
          // @ts-ignore
          useFunction: item.path,
          bizId: '',
        });
      } catch (e) {}
      IntentLauncher.startActivity({
        action: 'android.intent.action.MAIN',
        category: 'android.intent.category.LAUNCHER',
        packageName: 'com.jxw.launcher',
        className: 'com.jxw.launcher.ThemeActivity',
        flags: IntentConstant.FLAG_ACTIVITY_NEW_TASK,
      });
    }
    // 调用父组件传递的回调
  };
  return (
    <ScrollView style={styles.container}>
      <View style={styles.timelineContainer}>
        <View style={styles.dashedLine} />
        {scheduleList.map((item, index) => (
          <ScheduleTimelineItem
            key={index}
            item={item}
            isCurrentTime={item.time === currentTime}
            goToPage={goToPage}
          />
        ))}
        <UpgradeModal
          visible={showUpgradeModal}
          type="test"
          confirmText="重新生成"
          cancelText="继续测评"
          onConfirm={handleOnConfirmModal}
          onCancel={handleOnCancelModal}
        />
      </View>
    </ScrollView>
  );
};

const styles = createStyles({
  container: {
    flex: 1,
  },
  timelineContainer: {
    paddingLeft: 20,
    paddingRight: 16,
    paddingTop: 10,
    position: 'relative',
  },
  itemContainer: {
    marginBottom: '1.65rem',
    position: 'relative',
  },
  circleContainer: {
    position: 'absolute',
    left: '-1.03rem',
    top: 3,
    width: 12,
    height: 12,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  circle: {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#000',
    backgroundColor: 'white',
  },
  filledCircle: {
    backgroundColor: '#007AFF',
  },
  dashedLine: {
    position: 'absolute',
    left: '1.125rem',
    top: 0,
    bottom: 0,
    width: '0',
    borderStyle: 'dashed',
    borderWidth: '0.025rem',
    borderColor: '#3D3D3D',
    zIndex: 1,
  },
  timeAndContentContainer: {
    marginLeft: '0.8rem',
  },
  timeAndContentText: {
    fontSize: '1.1rem',
    color: '#3D3D3D',
  },
  logoContainer: {
    width: '17.5rem',
    height: '4.2rem',
    borderRadius: '0.6rem',
    overflow: 'hidden',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: '0.65rem',
    marginTop: '0.8rem',
    marginLeft: '0.8rem', // 调整左边距以对齐内容
  },
  logo: {
    width: '3.1rem',
    height: '3.1rem',
    resizeMode: 'contain',
    marginRight: '0.65rem',
  },
  logoTextContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'space-between',
    paddingVertical: '0.55rem',
  },
  subtitleText: {
    fontSize: '1.05rem',
    color: '#666666',
  },
  goToText: {
    fontSize: '0.85rem',
    color: '#666666',
    alignSelf: 'flex-end',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyText: {
    fontSize: 16,
    color: '#666',
  },
  goToContainer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  goToIcon: {
    width: '0.8rem',
    height: '0.75rem',
    resizeMode: 'contain',
  },
});

export default ScheduleTimeline;
